import { absolutePath } from "../../absolutePath";
import { affiliate } from "./affiliate";
import { billingInfo } from "./billingInfo";

export const communityMembers = {
  affiliate,
  billingInfo,
  billing: {
    index: () => absolutePath("paywalls/community_members/billing"),
  },
};
